import { EntityService, GlobalService } from "app/core/services";
import { Observable } from "rxjs";
import { Injectable } from "@angular/core";
import { MigratedClaim } from "../model/migratedClaim";
import { SearchMigratedClaimRequest } from "../model/requests/SearchMigratedClaimRequest";



@Injectable()
export class MigratedClaimService {
    constructor(
        private http: GlobalService,
        private entityService: EntityService
    ) { }


    search(request: SearchMigratedClaimRequest): Observable<MigratedClaim[]> {
        const url = `MigratedClaim/Search`;
        return this.http
            .post(url, request)
            .map((res) => this.entityService.extractData<MigratedClaim[]>(res))
            .map((data) => {
                return data.map((dataItem) => {
                    const sinester = new MigratedClaim();
                    return this.entityService.copy(dataItem, sinester);
                });
            });
    }
}



// WEBPACK FOOTER //
// C:/Users/Pablo/source/repos/prote/angular/src/app/shared-model/services/migratedclaim.service.ts